import React, { useState, useEffect } from 'react';
import Dbot from './delivery-bot.gif';

const LoaderTest = ({ image, width, messages, displayMessages = false }) => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    if (displayMessages && messages) {
      const messageInterval = setInterval(() => {
        setCurrentMessageIndex(prevIndex => (prevIndex + 1) % messages.length);
      }, 1500);

      return () => clearInterval(messageInterval);
    }
  }, [displayMessages, messages]);

  return (
    <div className='loader-container'>
      <style>
        {`
        .loader-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 1);
  z-index: 9998;
  display: flex;
  align-items: center;
  justify-content: center;
}

        `}
      </style>
      <div className='d-flex' style={{ position: 'absolute', zIndex: 9999, width: '100%' }}>
        <div className='d-flex flex-column justify-content-center col-12 mx-auto'>
          <div className='mx-auto'>
            <h2>On our way to retrieve your reports!</h2>
            <p>Thank you for waiting with us... Not everyone works as fast as we do.</p>
          </div>
          <iframe allowFullScreen='allowfullscreen' scrolling='no' class='fp-iframe' src={image} style={{ border: '0', width: '100%', height: '500px' }}></iframe>
          {displayMessages && messages && (
            <div className='bg-white p-3 rounded-4 fs-2' style={{ marginTop: '1rem', textAlign: 'center' }}>
              <p>{messages[currentMessageIndex]}</p>
            </div>
          )}
          <div className='row d-flex flex-row mx-auto'>
            <div className='col-6'>
              <img className='d-block' src={Dbot} width={200} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
{
  /*

  Here, we're adding a displayMessages prop to toggle message display, and a messages prop to pass the messages as an array. The component will cycle through the messages every 1 second (you can change the interval by modifying the value in setInterval).

You can now use the LoaderTest component like this:

<LoaderTest
  image="path/to/image"
  width="100px"
  displayMessages
  messages={[
    'Message one...',
    'Message two...',
    'Message three...',
    'Message four...',
    'Loading complete',
  ]}
/>

If you want to display the loader without messages, you can use it like this:

<LoaderTest image="path/to/image" width="100px" />

*/
}

export default LoaderTest;
